module.exports = __webpack_public_path__ + "media/WR Blob 7.9bbb53e8.mp3";